module.exports = __webpack_public_path__ + "static/media/photo102.d7cd1a1d.jpg";